// eslint-disable-next-line prefer-spread
export default (data: number[]) => Math.min.apply(Math, data)
